import { DateTime } from 'luxon';

export const fromISOtoDate = (exp: string) => {
    return DateTime.fromISO(exp).toJSDate();
};
